import { useEffect } from 'react';

import { auth } from '@/services/firebase.service';
import { syncPushSubscription } from '@/services/pushNotifications.service';

export default function PushSubscriptionSync() {
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        return;
      }
      // This only synchronizes a permission the user previously granted; it
      // never opens the browser permission prompt.
      syncPushSubscription().catch(() => {});
    });
    return unsubscribe;
  }, []);

  return null;
}
